// extracted by mini-css-extract-plugin
module.exports = {"container":"container--Tags-routes__1voXF","title":"title--Tags-routes__BYzGn"};